import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { StudentGrid } from '../../services/model/student-grid';

export const StudentGridActions = createActionGroup({
  source: 'Student Grid',
  events: {
    'Student Grids Loaded': props<{ studentGrids: StudentGrid[] }>(),
    'Student Grid Added': props<{ studentGrid: StudentGrid }>(),
    'Student Grid Courses Added': props<{ studentGridId: string; organizedCourseIds: string[] }>(),
    'Student Grid Course Removed': props<{ studentGridId: string; organizedCourseId: string }>(),
    'Student Grid Course Added': props<{ studentGridId: string; organizedCourseId: string }>(),
    'Reset': emptyProps(),
  },
});